import ownerDocument from './ownerDocument';
export default (function (componentOrElement) {
  var doc = ownerDocument(componentOrElement);
  return doc.defaultView;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/ownerWindow.js
// module id = 2902
// module chunks = 31